import {
  Box,
  CheckFilledIcon,
  Grid2,
  NumberIcon,
  PhoneIcon,
  Show,
  StatusField,
  Typography,
} from "components";
import { useFormContext } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { numberToCurrency } from "utils";
import { handleReturnAmount } from "utils/helpers";

const CompletedStep = () => {
  const form = useFormContext();

  const location = useLocation();

  const skipPayment =
    new URLSearchParams(location.search).get("skip_advance_fee") === "True";

  const checkGst = form.getValues("clientObject.onboardDetails.revenueWithGst");

  const onBoardingDetails = [
    {
      name: "Basket Name",
      value: form.getValues("clientObject.basket.name") || "-",
      show: form.getValues(
        "clientObject.onboardDetails.customizeSetting.basketFeePlan",
      ),
      statusComponent: false,
    },
    {
      name: "KYC",
      value: form.getValues("clientObject.kycDetails.kycStatus") || "-",
      show: form.getValues("clientObject.onboardDetails.customizeSetting.kyc"),
      statusComponent: true,
    },
    {
      name: "Risk Profile",
      value:
        form.getValues("clientObject.riskprofileDetails.riskStatus") || "-",
      show: form.getValues(
        "clientObject.onboardDetails.customizeSetting.riskprofiling",
      ),
      statusComponent: true,
    },
    {
      name: "Fee Plan",
      value: form.getValues("clientObject.advanceFeePlan.feePlan.name") || "-",
      show: form.getValues(
        "clientObject.onboardDetails.customizeSetting.basketFeePlan",
      ),
      statusComponent: false,
    },
    {
      name: "Agreement",
      value:
        form.getValues(
          "clientObject.agreementDetails.agreementStatus.status",
        ) || "Pending",
      show: form.getValues(
        "clientObject.onboardDetails.customizeSetting.agreement",
      ),
      statusComponent: true,
    },
    {
      name: "Payment Amount",
      value:
        numberToCurrency(
          handleReturnAmount({
            skipAdvanceFee: skipPayment,
            feePlanDetails: form.getValues(
              "clientObject.advanceFeePlan.feePlan",
            ),
            advanceFeePlan: form.getValues("clientObject.advanceFeePlan"),
            planDataObject: {
              holdingsValue: form
                .getValues("planDataObject.plansHoldings")
                .map(
                  (d: { cmp: string; quantity: string }) =>
                    +d.cmp * +d.quantity,
                ),
              aumCash: form.getValues("planDataObject.aumCash"),
            },
            isExitGST: checkGst,
          }),
        ) || "-",
      show: form.getValues(
        "clientObject.onboardDetails.customizeSetting.payment",
      ),
      statusComponent: false,
    },
  ];

  return (
    <Grid2 container sx={{ width: { xs: "80%", md: "60%" } }} m={"auto"} py={5}>
      <Grid2 size={12} textAlign={"center"}>
        <img src="/Investor/risk-success.svg" alt="" />
        <Typography fontWeight={600} fontSize={24}>
          You are successfully onboarded!
        </Typography>
      </Grid2>
      <Grid2
        container
        size={12}
        sx={{
          p: 2,
          background: "#F8FAFC",
          borderRadius: 2,
        }}
      >
        <Grid2
          size={{ xs: 12, md: 6 }}
          spacing={2}
          container
          justifyContent={"center"}
          flexDirection={"column"}
        >
          <Typography fontWeight={600} fontSize={18}>
            {form.getValues("clientObject.personalDetails.name") || "-"}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Box
              sx={{
                borderRadius: 100,
                background: "#E3E8EF",
                height: 40,
                width: 40,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <PhoneIcon />
            </Box>
            <Box>
              <Typography fontWeight={500} color={"#697586"} fontSize={12}>
                Phone No.
              </Typography>
              <Typography fontWeight={500} color={"#697586"} fontSize={14}>
                {form.getValues("clientObject.phone") || "-"}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Box
              sx={{
                borderRadius: 100,
                background: "#E3E8EF",
                height: 40,
                width: 40,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <NumberIcon />
            </Box>
            <Box>
              <Typography fontWeight={500} color={"#697586"} fontSize={12}>
                Client Code
              </Typography>
              <Typography fontWeight={500} color={"#697586"} fontSize={14}>
                {form.getValues("clientObject.code") || "-"}
              </Typography>
            </Box>
          </Box>
        </Grid2>
        <Grid2
          size={{ xs: 12, md: 6 }}
          container
          p={2}
          bgcolor={"#FFFF"}
          spacing={2}
          borderRadius={1}
        >
          {onBoardingDetails.map((dataItem) => {
            return (
              <Show.When isTrue={dataItem.show}>
                <Grid2 container size={12}>
                  <Grid2
                    size={12}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <CheckFilledIcon
                      color={"var(--success-700)"}
                      height={16}
                      width={16}
                    />
                    <Typography
                      fontWeight={500}
                      color={"#697586"}
                      fontSize={12}
                    >
                      {dataItem.name}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} ml={"28px"}>
                    {dataItem.statusComponent ? (
                      <StatusField statusString={dataItem.value} />
                    ) : (
                      <Typography fontWeight={500} color={"#333"} fontSize={14}>
                        {dataItem.value}
                      </Typography>
                    )}
                  </Grid2>
                </Grid2>
              </Show.When>
            );
          })}
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default CompletedStep;
